import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function getGuestId() {
  let id = localStorage.getItem("cpenz_guest_id");
  if (!id) {
    id = Math.random().toString(36).slice(2, 14);
    localStorage.setItem("cpenz_guest_id", id);
  }
  return id;
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const SESSION_KEY = "cpenz_session_token";

api.interceptors.request.use((config) => {
  config.headers["X-Guest-Id"] = getGuestId();
  const token = localStorage.getItem(SESSION_KEY);
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  try {
    const cs = sessionStorage.getItem("cpenz_creation_session");
    if (cs) config.headers["X-Creation-Session"] = cs;
    const dt = localStorage.getItem("cpenz_device_token");
    if (dt) config.headers["X-Device-Token"] = dt;
  } catch {}
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
